import { createApp } from 'vue'
import ToolApp from '../app/tool-app/ToolApp.vue'
import router from '../app/tool-app/router'
import Rails from '@rails/ujs';
window.Rails = Rails
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import nimbleai from "../app/model"
import RestService from "@/app/services/RestService.js";
import FolderService from "@/app/services/FolderService.js";
nimbleai.services.chatService = new RestService('chats')
nimbleai.services.chatGroupService = new RestService('chat-groups')
nimbleai.services.messageService = new RestService('messages')
nimbleai.services.folderService = new FolderService()
nimbleai.services.promptService = new RestService('prompts', '/')
nimbleai.services.imageService = new RestService('images')
window.nimbleai = nimbleai
const app = createApp(ToolApp)
app.use(router)
app.use(ToastPlugin)
app.mount('#app')